import { LatestAppointmentsExecuteScreen } from "../../screen/LatestAppointmentsExecuteScreen"

export const LatestAppointmentsExecuteContainer = ({ handleEventStatus }) => {
  return <LatestAppointmentsExecuteScreen {...{ handleEventStatus }} />
}